import * as React from "react"

import { ContextualHelpTerm } from "../../../../../models"
import Separator from "../../../../common/Separator"

interface Props {
    shouldShowSeparator: boolean
    term: ContextualHelpTerm
}

export const Term = ({ shouldShowSeparator, term }: Props): JSX.Element => {
    return (
        <div
            className="tw-mb-4"
            data-ft-component="term"
            data-ft-term-code={term.code}
            data-ft-term-label={term.label}
            data-ft-term-target={term.target}
        >
            {shouldShowSeparator && <Separator />}
            <header className="step-header">
                <h3 className="tw-my-2">{term.label}</h3>
            </header>
            <div
                className="tw-px-8 tw-py-2 tw-whitespace-pre-line"
                dangerouslySetInnerHTML={{
                    __html: term.content || "",
                }}
            />
        </div>
    )
}

export default Term
